module.exports = __webpack_public_path__ + "resources/img/bg_banner_ncc.084316d8c7a38784ecedb08056dd3e3b.png";